var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.$attrs.value},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }